export const message = `Your project may be large enough to qualify for special project pricing. Please contact Unirac's Support Team for further review at ISNST@unirac.com, subject "Project Pricing".`;

export function doesPromotionApply(totalWats: number): boolean {
  // return totalWats > 100000;
  return false;  // the promotion is disabled now.
}
